import {
  EnumFunnelTrackingCookies,
  setCookieWithFallback,
} from '@core/tracking/funnelTracking'

/**
 *
 */
export function persistLastEngagedVideoId(encodedVideoId: string) {
  setCookieWithFallback(
    EnumFunnelTrackingCookies.FW_LAST_ENGAGED_VIDEO_ID,
    encodedVideoId,
  )
}
